// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33928c15","519":"aeedb1ea","590":"fa62352f","740":"3ab3a28a","922":"1dc0f75f"}[chunkId] + ".chunk.js";
};